import script from "./Resultados.vue?vue&type=script&lang=ts&setup=true"
export * from "./Resultados.vue?vue&type=script&lang=ts&setup=true"

import "./Resultados.vue?vue&type=style&index=0&id=74afc381&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Scaleao\\Desktop\\Projetos Timo\\nutricao-inteligente-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74afc381"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel});
